import React, { useState, useEffect, useRef } from "react";
import QrScanner from "qr-scanner";
import "./QRScanner.css";

const QRScanner = ({ onScan }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [isPaused, setIsPaused] = useState(false);
  const videoRef = useRef(null);
  const scannerRef = useRef(null);

  useEffect(() => {
    // Check if we're on a mobile device
    setIsMobile(
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    );

    // Cleanup function
    return () => {
      if (scannerRef.current) {
        scannerRef.current.stop();
      }
    };
  }, []);

  useEffect(() => {
    let scanningPaused = false;
    if (isMobile && videoRef.current && scannerRef.current?._active !== true) {
      scannerRef.current = new QrScanner(
        videoRef.current,
        (result) => {
          if (result && !scanningPaused) {
            onScan(result.data);
            scanningPaused = true;
            setIsPaused(true);
            setTimeout(() => {
              scanningPaused = false;
              setIsPaused(false);
            }, 2000);
          }
        },
        {
          highlightScanRegion: true,
          highlightCodeOutline: true,
          maxScansPerSecond: 5,
        }
      );

      scannerRef.current.start().catch((err) => {
        console.error("Failed to start scanner:", err);
      });
    }
  }, [isMobile, onScan]);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      onScan(inputValue);
      setInputValue("");
    }
  };

  return (
    <div className="qr-scanner-container">
      {isMobile ? (
        <div className="camera-container" id="camera-container">
          <video ref={videoRef} className="qr-video"></video>
          {isPaused && (
            <div className="scanner-overlay">
              <div className="scanner-message">Scanning paused...</div>
            </div>
          )}
        </div>
      ) : (
        <div className="physical-scanner-container">
          <input
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Scan QR code or enter code manually"
            autoFocus
          />
        </div>
      )}
    </div>
  );
};

export default QRScanner;
